import "./deleteAccount.css";
import { useState } from "react";
import { icons, profileOutlinedDarkIcons } from "../../utils/globalImages";
import Toaster from "../../components/Toast/Toast";
import { logout } from "../../redux/slices/authSlice";
import { useDispatch, useSelector } from "react-redux";
import { deleteOwnAccount } from "../../api/modules/b2droppie.class";
import BackdropLoader from "../../components/BackdropLoader/BackdropLoader";

const DeleteAccount = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [toastMessage, setToastMessage] = useState(null);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const isDarkMode = useSelector((state) => state.theme.darkMode);

  const handleDeleteAccount = async () => {
    try {
      setLoading(true);
      const res = await deleteOwnAccount();
      if (res?.status === 200) {
        dispatch(logout());
      }
      setToastMessage({ success: res?.data?.message });
    } catch (err) {
      setToastMessage({ error: err?.response?.data?.message });
    } finally {
      setLoading(false);
      setShowConfirmModal(false);
    }
  };

  return (
    <>
      <Toaster message={toastMessage} />

      <div className={`delete-account-header ${isDarkMode ? "dark" : "light"}`}>
        <div className="delete-account-header-left">
          <div className="delete-account-icon">
            <img
              src={
                isDarkMode
                  ? profileOutlinedDarkIcons.trashCanOutlinedDark
                  : profileOutlinedDarkIcons.trashCanOutlinedPurple
              }
              alt="trash-can-outlined"
            />
          </div>
          <div className="delete-account-header-text">
            <h1 className="delete-account-title-header">Delete Account</h1>
            <p className="delete-account-subtitle-header">
              Deleting your account will permanently remove your profile,
              history, and data.
            </p>
          </div>
        </div>

        <div className="delete-account-header-right">
          <button
            className={`d-space-between gap-10px ${
              isDarkMode
                ? "filled-medium-deep-yellow-btn-dark"
                : "deep-primary-monochrome-btn-dark"
            }`}
            onClick={() => setShowConfirmModal(true)}
          >
            Delete Account
          </button>
        </div>
      </div>

      {/* Confirmation Modal */}
      {showConfirmModal && (
        <div className="delete-confirm-overlay">
          <div
            className={`delete-confirm-modal ${isDarkMode ? "dark" : "light"}`}
          >
            <h3>Are you absolutely sure?</h3>
            <p>
              This action cannot be undone. Your account and all associated data
              will be permanently deleted.
            </p>

            <div className="d-space-between gap-10px delete-confirm-actions">
              <button
                onClick={() => setShowConfirmModal(false)}
                className="deep-primary-monochrome-btn-dark"
              >
                Cancel
              </button>

              <button
                onClick={handleDeleteAccount}
                className="filled-medium-deep-yellow-btn-dark"
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      )}

      <BackdropLoader show={loading} />
    </>
  );
};

export default DeleteAccount;
